class PericiaJuicio {
    constructor({
        idNovedad,
        idTipoPericia,
        tipoPericia,
        idSubTipoPericia,
        subTipoPericia,
        fechaResultadoPericia,
        resultado,
        impugnada,
        nroSiniestro,
        montoIBM,
        porcIncapacidad,
        idDenuncia,
        esDesfavorable,
        observaciones,
        estado,
        idPerito,
        nombrePerito,
        apellidoPerito,
        intIdDomicilio,
        tipoPerito
    }) {
        this.idNovedad = idNovedad
        this.idTipoPericia = idTipoPericia
        this.tipoPericia = tipoPericia
        this.idSubTipoPericia = idSubTipoPericia
        this.subTipoPericia = subTipoPericia
        this.fechaResultadoPericia = fechaResultadoPericia
        this.resultado = resultado
        this.impugnada = impugnada
        this.nroSiniestro = nroSiniestro
        this.montoIBM = montoIBM
        this.porcIncapacidad = porcIncapacidad
        this.idDenuncia = idDenuncia
        this.esDesfavorable = esDesfavorable
        this.observaciones = observaciones
        this.estado = estado
        this.idPerito = idPerito
        this.nombrePerito = nombrePerito
        this.apellidoPerito = apellidoPerito
        this.intIdDomicilio = intIdDomicilio
        this.tipoPerito = tipoPerito
    }
}

export default PericiaJuicio